import { AfterViewInit, Component, inject, Input, OnInit, ViewChild } from  "@angular/core";
import { ComponentConfig } from "../../cockpitComponents";
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { CdkDropList, DragDropModule } from '@angular/cdk/drag-drop';
import { DropListRegistryService } from "../drop-list-registry.service";

@Component({
  selector: 'app-designer-cockpit-component-list',
  templateUrl: 'design.cockpit.list.component.html',
  styleUrl: 'design.cockpit.list.component.css',
  imports: [ MatCardModule, MatIconModule, DragDropModule ], 
})

export class DesignCockpitComponentList  implements OnInit, AfterViewInit{
    private registry = inject(DropListRegistryService)
    @Input() components: ComponentConfig[] = [];
    @ViewChild(CdkDropList) sidebarList!: CdkDropList;
    readonly componentsItems:any  = []

     ngOnInit() {
  console.log("components (ngOnInit) sidebar", this.components);
}

ngAfterViewInit(): void {
  this.registry.register(this.sidebarList);
}

getConnectedLists() {
    return this.registry.getAll();
  }

    constructor(){
      console.log("components", this.components.length)
      this.componentsItems = this.components.map((cm)=>{cm.defaultItem}) ?? [];
    }
}